class WorkshopOpeningHour {
  constructor(id, dayOfWeek, opensAt, closesAt, closed, opened24h, workshopTypesForDay) {
    this.id = id;
    this.dayOfWeek = dayOfWeek;
    this.opensAt = opensAt;
    this.closesAt = closesAt;
    this.closed = closed;
    this.opened24h = opened24h;
    this.workshopTypesForDay = workshopTypesForDay;
  }
}

export default WorkshopOpeningHour;
